

import { SubDomain } from "../../../../SubDomain.js";
import Note from "./Note.js";

export default class NotesDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Note.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Note(this.domain, item);
      }
    }

    return new Note(this.domain);
  }
  
}